import { View, type ViewProps } from "react-native";

/**
 * Web stub for KeyboardStickyView.
 * On native, this is replaced by the react-native-keyboard-controller version.
 * On web, keyboards don't overlap content, so we render a View that forwards layout props.
 */
export const KeyboardStickyView = ({
  children,
  offset: _offset,
  ...viewProps
}: ViewProps & {
  offset?: {
    opened?: number;
    closed?: number;
  };
}) => <View {...viewProps} data-sentry-element="View" data-sentry-component="KeyboardStickyView" data-sentry-source-file="KeyboardStickyView.tsx">{children}</View>;